import { combineReducers } from 'redux';

import isLoadingBookingTask from './isLoadingBookingTask';
import isLoadingTask from './isLoadingTask';
import isResolving from './isResolving';
import isUpdatingMedia from './isUpdatingMedia';
import showAddDriverLicence from './showAddDriverLicence';

export default combineReducers({
  isResolving,
  isLoadingTask,
  isUpdatingMedia,
  isLoadingBookingTask,
  showAddDriverLicence,
});
